<template>
  <div class="inline-flex items-center">
    <span class="border-2 border-solid border-primary-normal bg-primary-normal mr-xs h-[14px] inline-block box-border"></span>
    <span
      class="text-16 text-word-new-title"
      :class="props.bold ? 'font-bold' : ''">
      <span v-if="!slots.label">{{ props.label }}</span>
      <slot
        v-else
        name="label"></slot>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { ref, useSlots } from "vue";

const slots = useSlots();
const props = defineProps({
  label: {
    type: String,
    default: "标题"
  },
  bold: {
    type: Boolean,
    default: false
  }
});
</script>
